import React, { useState } from 'react';

/** Initials used for the gradient tile when an icon file is missing. */
const monogram = name =>
    name
        .replace(/[^\w\s]/g, ' ')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(word => word[0].toUpperCase())
        .join('');

/**
 * App icon with a graceful fallback: if the image is absent or fails to load,
 * render a gradient tile with the app's initials instead of a broken image.
 */
export default function AppIcon({ app, className = '' }) {
    const [failed, setFailed] = useState(false);
    const showImage = Boolean(app.image) && !failed;
    const [from, to] = app.accent || ['#6366f1', '#22d3ee'];

    return (
        <div className={`app-icon ${className}`.trim()}>
            {showImage ? (
                <img
                    src={`/images/${app.image}`}
                    alt=""
                    loading="lazy"
                    decoding="async"
                    onError={() => setFailed(true)}
                />
            ) : (
                <div
                    className="app-icon-fallback"
                    style={{ background: `linear-gradient(140deg, ${from}, ${to})` }}
                >
                    {app.monogram || monogram(app.name)}
                </div>
            )}
        </div>
    );
}
